export default "__VITE_ASSET__aECnbGQf__"